module.exports = "//img1.rrcimg.com/_next/static/src/assets/hrb_3fW4w.png";